<template>
    <Head>
        <title>{{ get_title }}</title>
        <meta
            :content="get_description" type="description"
        />
        <meta
            content="summary" name="twitter:card"
        />
        <meta
            :content="page.props.ziggy.location" property="og:url"
        />
        <meta
            :content="get_type" property="og:type"
        />
        <meta
            :content=get_title property="og:title"
        />
        <meta
            :content="get_description" property="og:description"
        />
        <meta
            :content="get_image" property="og:image"
        />
        <meta
            content="ru_RU" property="og:locale"
        />
    </Head>
</template>
<script setup>
import {Head} from '@inertiajs/vue3';
import {computed, ref, onMounted} from 'vue';
import {aws_bucket} from '@/shared/helpers.js';
import {page} from '@/shared/helpers.js';
import {login} from '@/editor/helpers.js';

const props = defineProps(['element']);

let type = ref('website');
let title = ref('');
let description = ref('');
let url = ref('');
onMounted(() => url.value = page.props.ziggy.location);

let get_type = computed(() => type.value ?? 'website');
let get_title = computed(() => (props.element.title || props.element.name) ?? getTitleFromUrl());

let get_image = computed(() => props.element.img ? aws_bucket + props.element.img : aws_bucket + 'favicon.svg');

let get_description = computed(() => props?.element?.description?.replaceAll(/<\/?[^>]+(>|$)/g, '') ?? description.value.replaceAll(/<\/?[^>]+(>|$)/g, ''));

function getTitleFromUrl() {
    switch (url.value) {
        case url.value.includes('event'):
            title.value = 'Прямой эфир';
            break;
        case url.value.includes('articles'):
            title.value = 'Статьи';
            break;
        case url.value.includes('vacancies'):
            title.value = 'Вакансии';
            break;
        case url.value.includes('multimedia'):
            title.value = 'Мультимедиа';
            break;
        case url.value.includes('tools'):
            title.value = 'Инструменты';
            break;
        case url.value.includes('events'):
            title.value = 'События';
            break;
        case url.value.includes('academy'):
            title.value = 'Академия';
            break;
    }
    return title.value;
}
</script>
